export const en = {
    icon: {
        'SME': 'mdi-factory',
        'MIKRO': 'mdi-account-group'
    },
    msg:
        {/*The maximum entry is 999999999.*/
            'applicationNumber_error_max': 'Maximum length should be less than 10 digits.',
            'applicationNumber_error_required': 'Please enter customer\'s application number.',
            'applicationNumber_error_numeric': 'Only numbers are allowed.',
            'applicationNumber_error_alpha_num': 'Only alphabets and numbers are accepted.',
            'applicationNumber_error_0': 'Application Number already exists',

            'fullName_error_required': 'Please enter customer\'s full name as indicated on your NRIC.',
            'fullName_error_min': 'Full Name must be at least 5 characters long.',
            'fullName_error_regex': 'Only letters of the alphabet, spaces, and the following special characters: @ ’ - and / are accepted.',
            'fullName_error_max': 'Full Name cannot be longer than 80 characters.',

            'gender_error_required': 'Please select customer\'s  gender.',

            'ethnicity_error_required': 'Please select customer\'s ethnicity.',
            'otherEthnicity_error_required': 'Please provide customer\'s ethnicity.',

            'position_error_min': 'Minimum length should be at least 10 characters.',
            'position_error_max': 'Maximum length should be less than 10 characters.',
            'position_error_required': 'Please enter customer\'s position.',
            'position_error_regex': 'Only alphabet, spaces, numerals, and the following special characters: . - & () and ’ are accepted.',

            'companyName_error_required': 'Please enter customer\'s company name.',
            'companyName_error_min': 'Company name must be at least 5 characters long.',
            'companyName_error_regex': 'Only alphabet, spaces, numerals, and the following special characters: . - & () and ’ are accepted.',
            'companyName_error_max': 'Company name must not be longer than 80 characters.',

            'ctosRating_error_min_value': 'CTOS Rating should not be less than 300.',
            'ctosRating_error_max_value': 'CTOS Rating should not be greater than 850.',

            'employeesCount_error_required': 'Please enter number of employees(s).',
            'employeesCount_error_min_value': 'The minimum entry is 0.',
            'employeesCount_error_max_value': 'The maximum entry is 999999999.',
            'employeesCount_error_numeric': 'Only numbers are allowed.',

            'annualSales_error_required': 'Please enter customer\'s  annual sales.',
            'annualSales_error_numeric': 'Only numbers are allowed.',
            'annualSales_error_max_value': 'The maximum entry is 999999999.',
            'annualSales_error_min_value': 'The minimum entry is 1.',

            'annualProfit_error_required': 'Please enter customer\'s  annual profit.',
            'annualProfit_error_numeric': 'Only numbers are allowed.',
            'annualProfit_error_max_value': 'Annual profit cannot be greater than annual sales.',
            'annualProfit_error_min_value': 'The minimum entry is 1.',

            'officerName_error_required': 'Please enter CGC staff name.',
            'officerName_error_regex': 'The only acceptable characters are letters of the alphabet, spaces, and the following special characters: @ ’ - and /',
            'officerName_error_min': 'Staff Name must be at least 5 characters long.',
            'officerName_error_max': 'Staff Name cannot be longer than 80 characters.',

            'officerId_error_required': 'Please enter CGC staff Id.',
            'officerId_error_numeric': 'Only numbers are allowed.',
            'officerId_error_min': 'Staff ID must be at least 4 characters long.',
            'officerId_error_max': 'Staff ID number cannot be longer than 6 characters.',

            'financingAmount_error_required': 'Please enter financing amount.',
            'financingAmount_error_max_value': 'The maximum entry is 999999999.',
            'financingAmount_error_min_value': 'The minimum entry is 1000.',
            'financingAmount_error_numeric': 'Only numbers are allowed.',

            'tenureApplied_error_required': 'Please enter tenure applied.',
            'tenureApplied_error_max_value': 'The maximum entry is 180.',
            'tenureApplied_error_min_value': 'The minimum entry is 1.',
            'tenureApplied_error_numeric': 'Only numbers are allowed.',

            'businessCategory_error_required': 'Please select main sector.',

            'approved_date_error_required':'Please enter application approval date.',

            'financingAmountApproved_error_required': 'Please enter financing amount approved.',
            'financingAmountApproved_error_numeric': 'Only numbers are allowed.',
            'financingAmountApproved_error_min_value': 'The minimum entry is 1000.',
            'financingAmountApproved_error_max_value': 'The maximum entry is 999999999.',

            'tenureApproved_error_numeric': 'Only numbers are allowed.',
            'tenureApproved_error_required': 'Please enter tenure approved.',
            'tenureApproved_error_max_value': 'The maximum entry is 180.',
            'tenureApproved_error_min_value': 'The minimum entry is 1.',

            // Login
            'username_error_required': 'Please enter your username.',
            'password_error_required': 'Please enter your password.',

            // Dashboard
            'export_button': 'Export',

            // Headers
            'sl_no': 'No.',
            'verification_code': 'Verification Code',
            'br_number': 'Business Registration (BR) No.',
            'company_name': 'Company Name',
            'id_number': 'Identification Number (ID)',
            'business_category': 'Business Category',
            'business_licence': 'Business Licence No.',
            'staff_id_number': 'Staff ID No.',
            'branch': 'Branch',
            'scheme': 'Scheme       ',
            'financing_amount_requested': 'Financing Amount',
            'tenure_applied': 'Tenure',
            'gfi_status': 'GFI Status',
            'gfi_registration_date': 'GFI Registration Date',
            'gfi_completion_date': 'GFI Completion Date',
            'update_details': 'Update Details',
            'gfi_scoring': 'Generate Score',
            'application_status': 'Application Status',
            'report': 'Report',
            'expiry_date':'GFI Expiry Date',
            'f1': 'F1',
            'f2': 'F2',
            'f3': 'F3',
            'gfi_rating': 'GFI Rating',
                'gfi_score':'GFI Score',
            'assessment_type_label':'Type',
            'application_number': 'Application No.',
            'compliance':'Compliance',

            // Dropdowns
            'scheme_label': 'Scheme',
            'amount_range_label': 'Financing Amount Range',
            'gfi_status_label': 'GFI Status',
            'financing_application_status_label': 'Financing Application Status',
            'date_label': 'GFI Registration Date',
            'branch_label': 'Branch',
            'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support.',
            'export_unavailable': 'We encountered an error while exporting data , please try again.<br>If the problem persists please contact support.',
            'close_label': 'Close',
             'customerApplicationStatus_error_required': 'Please select the application status',

            // TimeOut Dialog
            'session_expire_heading': 'Session Expiration Warning',
            'session_expire_message_1': 'Your session will expire in',
            'session_expire_message_2': 'seconds. Please click “Continue” to continue your session or click “Log Out Now” to end your session now.',

            'table_heading_export':'Data Export History',
            'table_header_no': 'No.',
            'table_header_date': 'Export Date',
            'table_header_finance_type': 'Finance Type',
            'table_header_filter_applied': 'Filters Applied',
            'table_header_status':'Status',
            'table_header_download':'Download'
        }
}
